export enum ChecklistItemStatusEnum {
  todo = 'todo',
  done = 'done',
}
